export const imageExtensions = ["jpg", "jpeg", "png", "webp", "gif", "ico"];

export const documentExtensions = ["csv", "xls", "xlsx", "txt", "doc", "docx", "pdf", "cdr", "zip"];

export const fileExtensions = new Set([...imageExtensions, ...documentExtensions]);

export const MAX_FILE_SIZE = 20971520; // 20971520 байт = 20 мб

export const MAX_FILE_SIZE_MB = Math.floor(MAX_FILE_SIZE / 1024 / 1024);

// Значение для атрибута accept у <input type="file" />
export const fileAccept = [...fileExtensions].map((ext) => `.${ext}`).join(",");

export const getFileExtension = (fileName) => {
  if (typeof fileName !== "string") return "";
  const dotIdx = fileName.lastIndexOf(".");
  if (dotIdx === -1) return "";
  return fileName.slice(dotIdx + 1).trim().toLowerCase();
};

export const isFileAllowed = (file) =>
  Boolean(file) &&
  file.size < MAX_FILE_SIZE &&
  fileExtensions.has(getFileExtension(file.name));
